import { ActivityEntityName } from '../../../../entities/shared/activity.entity.name';
import { MergeDataset } from '../../decorators/decorators/merge.dataset';
import { MergeSource } from '../../decorators/decorators/merge.source';
import { AccountMergeData, AccountMergeSchema } from '../data/account.merge.data';
import { ContactFullMergeData, ContactFullMergeSchema } from '../data/contact.full.merge.data';
import { SiteMergeData, SiteMergeSchema } from '../data/site.merge.data';

@MergeDataset({
    entity: ActivityEntityName.Site,
})
export class SiteMergeDataset {
    @MergeSource({
        schema: SiteMergeSchema
    })
    site: SiteMergeData;

    @MergeSource({
        schema: ContactFullMergeSchema,
        ignoreCustomFields: true,
        ignoreFields: ["jobTitle"]
    })
    primaryContact: ContactFullMergeData;

    @MergeSource({
        schema: ContactFullMergeSchema,
        ignoreCustomFields: true,
        ignoreFields: ['jobTitle']
    })
    owner: ContactFullMergeData;

    @MergeSource({
        schema: ContactFullMergeSchema,
        ignoreCustomFields: true,
        ignoreFields: ['jobTitle']
    })
    siteManager: ContactFullMergeData;

    @MergeSource({
        schema: AccountMergeSchema,
        ignoreCustomFields: true,
    })
    relatedTo: AccountMergeData;
}